// extracted by mini-css-extract-plugin
export default {"filter":"Filter-module--filter--1cbcf"};